export const QUERY_KEYS = {
  catalog: {
    appIdLookup: (appId: string, offset: number, limit: number) =>
      ['app', 'catalog', 'app-id-lookup', appId, offset, limit] as const,
  },
  scaffolder: {
    ownedEntities: (techDocsOnly: boolean) =>
      ['app', 'scaffolder', 'owned-entities', techDocsOnly] as const,
    entraGroups: (startsWith: string) => ['app', 'scaffolder', 'entra-groups', startsWith] as const,
    configurationItems: (startsWith: string) => ['app', 'scaffolder', 'ci', startsWith] as const,
    azureSubscriptions: () => ['app', 'scaffolder', 'azure-subscriptions'] as const,
    azureResourceGroups: (subscriptionId: string) =>
      ['app', 'scaffolder', 'azure-resource-groups', subscriptionId] as const,
  },
};
